<template>
  <div class="container-fluid">
    <div class="row no-margin-left-right-for-header">
      <div class="col-sm-12 no-padding-right navigator-container">
        <div class="title-dashboard title-text pl-0">Dashboard</div>
        <ul class="menu-list">
          <li class="menu-item" :class="{ 'active': item.active }" v-for="(item, index) in navItems" :key="item.url"
              v-if="!item.overview" @click="clickItem(item)">
            {{item.text}}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
  import NavigatorItem from './NavigatorItem';
  import {mapActions, mapGetters} from 'vuex';

  export default {
    name: 'navigator',
    components: {
      NavigatorItem
    },
    props: {
      navItems: {
        type: Array,
        default: []
      }
    },
    methods: {
      clickItem (item) {
        this.navItems.forEach((element, index) => {
          this.navItems[index].active = element.text === item.text;
        });
        this.$router.push({name: item.viewName});
      },
      ...mapActions({
        getEventCountByClientId: 'ACTION_GET_EVENT_COUNT_BY_CLIENT'
      })
    },
    computed: {
      ...mapGetters({
        getClientListId: 'GETTERS_CLIENT_LIST_ID'
      })
    },
    created () {
      this.navItems.forEach((element, index) => {
        this.navItems[index].active = element.viewName === this.$router.currentRoute.name;
      });
    },
    watch: {
      getClientListId: {
        handler: function () {
          this.getEventCountByClientId(this.getClientListId);
        }
      }
    }
  };
</script>

<style lang="less" scoped>
  @import "~@/styles/variables.less";

  .navigator-container {
    background-color: #3d6274;
    padding-left: 35px;
    .title-dashboard {
      color: #FFFFFF;
      font-family: "Open Sans", sans-serif;
      font-size: 32px;
      font-weight: 800;
      letter-spacing: -1px;
      line-height: 40px;
      text-transform: uppercase;
      margin-top: 25px;
      margin-bottom: 15px;
    }
    ul.menu-list {
      height: 30px;
      background-color: @dark-blue;
      list-style-type: none;
      margin: 0;
      padding: 0;
      li.menu-item {
        float: left;
        margin: 0 50px 0 0;
        color: @white;
        padding-bottom: 7px;
        border-bottom: solid 3px @dark-blue;
        a {
          display: block;
          color: @white;
        }
        &.active {
          border-bottom: solid 3px @light-blue;
          color: @light-blue;
        }
        &:hover {
          border-bottom: solid 3px @light-blue;
          color: @light-blue;
          cursor: pointer;
        }
      }
    }
  }

  .title-container {
    .title-text {
      margin-top: 30px;
    }
  }

  @media screen and (max-width: 800px) {
    ul.menu-list {
      li.menu-item:first-child {
        margin-left: 0;
      }
    }
  }

  .navigator-header {
    padding: 0 0 0 15px;
  }

  .no-margin-left-right-for-header {
    margin-right: 0;
  }

  .no-padding-right {
    padding-right: 0;
  }
</style>




// WEBPACK FOOTER //
// Navigator.vue?95633386